export const USER_ROLES = ['PLATFORM_ADMIN', 'OWNER', 'MANAGER', 'STAFF'];
/**
 * Roles attribuables depuis le back-office d'un restaurant.
 *
 * `PLATFORM_ADMIN` en est exclu : l'ecran « Equipe » le proposait et l'API
 * l'acceptait, de sorte qu'un gerant pouvait se creer un compte administrant
 * **tous** les restaurants. Un compte de plateforme ne se cree que par le
 * script d'amorcage, sur le serveur. Voir docs/adr/0030 et 0014.
 */
export const RESTAURANT_ROLES = ['OWNER', 'MANAGER', 'STAFF'];
/**
 * Hierarchie des roles. Un rang superieur possede tous les droits des rangs
 * inferieurs. Utilise par requireRole cote API.
 */
export const ROLE_RANK = {
    PLATFORM_ADMIN: 4,
    OWNER: 3,
    MANAGER: 2,
    STAFF: 1,
};
export function hasRoleAtLeast(role, minimum) {
    return ROLE_RANK[role] >= ROLE_RANK[minimum];
}
//# sourceMappingURL=auth.js.map